"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.main = void 0;
var util = require("./util");
var api_1 = require("./api");
var jwt = require("jsonwebtoken");
var main = /** @class */ (function () {
    function main(s) {
        var _this = this;
        // ===========================
        this.app_version_ = "XXX_CATALANA_VERSION_NO_XXX";
        this.app_hash_ = "XXX_CATALANA_VERSION_HASH_XXX";
        // ===========================
        this.access_token_ = "";
        // 外部からの指定によるアクションボタンの追加
        this.createButtons = function (s) {
            var _a;
            if (!s)
                return;
            var box = util.js.gE("box_action_main");
            (_a = s.buttons) === null || _a === void 0 ? void 0 : _a.some(function (b) {
                var div = util.js.cE("div");
                div.classList.add("c-form");
                var button = util.js.cE("button");
                button.innerText = b.cap;
                button.onclick = function () {
                    var datas = _this.checkSelect(b.count, b.mimes);
                    if (!datas)
                        return false;
                    b.action(datas, _this.access_token_);
                };
                div.append(button);
                box.append(div);
            });
        };
        this.window_resize = function () {
            var aHeight = window.innerHeight;
            var box_list = util.js.gE("box_list");
            var box_list_head = util.js.gE("box_list_head");
            var box_header = util.js.gE("box_header");
            var box_cmd = util.js.gE("box_cmd");
            var box_paging = util.js.gE("box_paging");
            var box_action = util.js.gE("box_action");
            box_list.style.height = (aHeight - box_list_head.clientHeight - box_header.clientHeight - box_cmd.clientHeight - box_paging.clientHeight - box_action.clientHeight - 4) + "px";
        };
        this.set_option = function (sel, text, val) {
            var op = util.js.cE("option");
            op.text = text;
            op.value = val;
            sel.append(op);
        };
        this.btn_swagger = function () {
            window.open('swagger/index.html', '_blank');
            return false;
        };
        this.btn_token = function () {
            _this.show_dlg_token();
            return false;
        };
        this.btn_sysdir = function () {
            _this.show_dlg_sysdir();
            return false;
        };
        /**
         * 選択データのチェック
         * @param count 1以上：指定件数かどうかチェック｜-1：1件以上ならOK｜-2：何件でもOK
         * @param mimes 指定mimeのみOK。未設定の場合はフリー
         * @returns
         */
        this.checkSelect = function (count, mimes) {
            var datas = _this.get_select_rows();
            if (count == -2) { } // 何件でも良し
            else if (count == -3 && datas.length > 1) {
                // 1件以下
                _this.msg("ワーニング", "2件以上選択できません。", function () { });
                return null;
            }
            else if (count == -1 && datas.length == 0) {
                // 1件以上
                _this.msg("ワーニング", "対象を1件以上選択してください。", function () { });
                return null;
            }
            else if (count >= 0 && datas.length != count) {
                // 既定件数
                _this.msg("ワーニング", "対象を1件のみ選択してください。", function () { });
                return false;
            }
            if (!mimes || mimes.length == 0) { }
            else if (datas.some(function (d) { return mimes.indexOf(d.mime_type) == -1; })) {
                _this.msg("ワーニング", "データの種類が不正です。<br><br>[有効な種類]<br>" + mimes.join(" ,"), function () { });
                return false;
            }
            return datas;
        };
        //#region msgbox
        this.msg = function (title, msg, okfunc, okcap, canfunc, cancap) {
            if (okcap === void 0) { okcap = "OK"; }
            if (canfunc === void 0) { canfunc = null; }
            if (cancap === void 0) { cancap = "キャンセル"; }
            var msg_layer = util.js.gE("msg_layer");
            var msg_box = util.js.gE("msg_box");
            var msg_box_title = util.js.gE("msg_box_title");
            var msg_box_content = util.js.gE("msg_box_content");
            var msg_box_cancel = util.js.gE("msg_box_cancel");
            var msg_box_ok = util.js.gE("msg_box_ok");
            msg_box_title.innerText = title;
            msg_box_content.innerHTML = msg;
            var focus = msg_box_ok;
            msg_box_ok.innerText = okcap;
            msg_box_ok.onclick = function () {
                msg_layer.style.display = "none";
                msg_box.style.display = "none";
                okfunc();
            };
            if (canfunc == null) {
                msg_box_cancel.style.display = "none";
            }
            else {
                msg_box_cancel.innerText = cancap;
                msg_box_cancel.style.display = "inline";
                msg_box_cancel.onclick = function () {
                    msg_layer.style.display = "none";
                    msg_box.style.display = "none";
                    canfunc();
                };
                focus = msg_box_cancel;
            }
            msg_layer.style.display = "block";
            msg_box.style.display = "block";
            focus.focus();
        };
        this.apiError = function (e) {
            var msg = "status_code：" + e.responseCode;
            if (e.response) {
                msg += "<br>";
                msg += "title：" + e.response.title;
                if (e.response.tracking_code) {
                    msg += "<br>";
                    msg += "tracking_code：" + e.response.tracking_code;
                }
                if (e.response.detail) {
                    msg += "<br>";
                    msg += "detail：" + e.response.detail;
                }
                if (e.response.detail) {
                    msg += "<br>";
                    msg += "detail：" + e.response.detail;
                }
                if (e.response.type) {
                    msg += "<br>";
                    msg += "type：";
                    msg += "<a href='" + e.response.type + "' target='_blank'>" + e.response.type + "</a>";
                }
            }
            _this.msg("APIエラー", msg, function () { });
        };
        //#endregion
        //#region dailog
        this.showDlg = function (id) {
            var dlg_layer = util.js.gE("dlg_layer");
            var dlg = util.js.gE(id);
            dlg_layer.style.display = "block";
            dlg.style.display = "block";
        };
        this.closeDlg = function (id) {
            var dlg_layer = util.js.gE("dlg_layer");
            var dlg = util.js.gE(id);
            dlg_layer.style.display = "none";
            dlg.style.display = "none";
        };
        //#endregion
        //#region 一覧検索関連
        // 一覧表示MAX件数
        this.page_max_count_ = 200;
        this.page_search_len_ = 0;
        this.page_search_idx_ = -1;
        this.page_cond_name_ = "";
        this.page_cond_mimes_ = [];
        this.page_cond_subs_ = [];
        this.page_sel_toggle_ = false;
        this.disp_page_idx = function () {
            var box_paging_idx = util.js.gE("box_paging_idx");
            box_paging_idx.innerHTML = "";
            if (_this.page_search_len_ == 0)
                return;
            var page_cnt = Math.ceil(_this.page_search_len_ / _this.page_max_count_);
            var adda = function (str, idx) {
                var a = util.js.cE("a");
                a.innerText = str;
                a.onclick = function () {
                    if (idx == _this.page_search_idx_)
                        return false;
                    _this.page_search_idx_ = idx;
                    _this.get_page_list();
                    return false;
                };
                box_paging_idx.append(a);
            };
            if (page_cnt > 1) {
                adda("<", 0);
            }
            for (var i = 0; i < page_cnt; i++) {
                adda((i + 1).toString(), i);
            }
            if (page_cnt > 1) {
                adda(">", page_cnt - 1);
            }
        };
        this.disp_page_fully = function () {
            var box_paging_fully = util.js.gE("box_paging_fully");
            box_paging_fully.innerHTML = "";
            if (_this.page_search_len_ == 0) {
                box_paging_fully.innerText = "( " + _this.page_search_len_ + "件 )";
                return;
            }
            if (_this.page_search_idx_ < 0)
                return;
            var scnt = (_this.page_search_idx_ * _this.page_max_count_) + 1;
            var ecnt = (_this.page_search_idx_ + 1) * _this.page_max_count_;
            if (ecnt > _this.page_search_len_)
                ecnt = _this.page_search_len_;
            if (scnt > ecnt)
                scnt = ecnt;
            var str = "( " + scnt.toString() + " - " + ecnt.toString() + " / " + _this.page_search_len_ + "件 )";
            box_paging_fully.innerText = str;
        };
        this.get_page_init = function () {
            var ipt_token = util.js.gE("ipt_token");
            /*
            if(ipt_token.value =="")
            {
                this.msg("ワーニング","アクセストークンが指定されていません。",()=>{});
                return;
            }
            */
            _this.access_token_ = ipt_token.value;
            _this.page_search_len_ = 0;
            _this.page_sel_toggle_ = false;
            _this.page_search_idx_ = -1;
            var ipt_search_name = util.js.gE("ipt_search_name");
            var ipt_search_subtype = util.js.gE("ipt_search_subtype");
            _this.page_cond_name_ = ipt_search_name.value;
            _this.page_cond_mimes_ = [];
            _this.page_cond_subs_ = [];
            if (ipt_search_subtype.value != "")
                _this.page_cond_subs_.push(ipt_search_subtype.value);
            _this.disp_page_idx();
            _this.disp_page_fully();
            _this.get_page_list();
            api_1.api.reflesh(_this.access_token_).then(function () {
                api_1.api.fileLength(_this.page_cond_mimes_, _this.page_cond_name_, _this.page_cond_subs_, _this.access_token_).then(function (r) {
                    _this.page_search_len_ = r.res;
                    _this.page_search_idx_ = 0;
                    _this.disp_page_idx();
                    _this.disp_page_fully();
                    _this.get_page_list();
                }).catch(function (e) { return _this.apiError(e); });
            }).catch(function (e) { return _this.apiError(e); });
        };
        this.get_page_list = function () {
            var tbl = util.js.gE("box_list_tbl");
            tbl.innerHTML = "";
            if (_this.page_search_len_ == 0)
                return;
            if (_this.page_search_idx_ < 0)
                return;
            api_1.api.files(_this.page_cond_mimes_, _this.page_cond_name_, _this.page_cond_subs_, _this.page_search_idx_ * _this.page_max_count_, _this.page_max_count_, _this.access_token_).then(function (r) {
                var datas = r.res;
                datas.some(function (data) {
                    var row = tbl.insertRow(tbl.rows.length);
                    row.setAttribute("file_key", data.file_key);
                    row.setAttribute("name", data.name);
                    row.setAttribute("mime_type", data.mime_type);
                    row.setAttribute("sub_type", data.sub_type);
                    row.onclick = function () { return _this.list_row_select(row); };
                    // check
                    {
                        var cell = row.insertCell(0);
                        var check = util.js.cE("input");
                        check.type = "checkbox";
                        cell.append(check);
                    }
                    // file_key
                    {
                        var cell = row.insertCell(1);
                        var a = util.js.cE("a");
                        a.innerText = data.file_key;
                        a.onclick = function (e) {
                            _this.msg("ファイルキー", data.file_key, function () { });
                            e.stopPropagation();
                        };
                        cell.append(a);
                    }
                    // name
                    {
                        var cell = row.insertCell(2);
                        cell.innerText = data.name;
                    }
                    // sub_type
                    {
                        var cell = row.insertCell(3);
                        cell.innerText = data.sub_type;
                    }
                    // mime
                    {
                        var cell = row.insertCell(4);
                        var span = util.js.cE("span");
                        span.innerText = data.mime_type;
                        span.classList.add("c-mime");
                        var m = data.mime_type.split("/");
                        if (m.length > 0 && m[m.length - 1]) {
                            span.classList.add("c-mime-" + m[m.length - 1]);
                        }
                        cell.append(span);
                    }
                });
                _this.disp_page_fully();
            }).catch(function (e) { return _this.apiError(e); });
        };
        this.list_row_select = function (row) {
            var onsel = row.getAttribute("on-select");
            var check = row.firstChild.firstChild;
            if (onsel && onsel == "true") {
                check.checked = false;
                row.removeAttribute("on-select");
            }
            else {
                check.checked = true;
                row.setAttribute("on-select", "true");
            }
        };
        this.list_loop = function (id, func) {
            var tbl = util.js.gE(id);
            for (var i = 0; i < tbl.rows.length; ++i) {
                var row = tbl.rows[i];
                if (func(row))
                    break;
            }
        };
        this.get_select_rows = function () {
            if (_this.page_max_count_ == 0)
                return [];
            var result = [];
            _this.list_loop("box_list_tbl", function (row) {
                if (row.getAttribute("on-select") == "true") {
                    var file_key = row.getAttribute("file_key");
                    var mime_type = row.getAttribute("mime_type");
                    var sub_type = row.getAttribute("sub_type");
                    var name_1 = row.getAttribute("name");
                    result.push({ file_key: file_key, mime_type: mime_type, sub_type: sub_type, name: name_1 });
                }
                return false;
            });
            return result;
        };
        this.btn_search = function () {
            _this.get_page_init();
            return false;
        };
        this.ipt_cond_keydown = function (e) {
            if (e.key === 'Enter') {
                _this.get_page_init();
                return false;
            }
        };
        this.box_list_head_sel = function () {
            if (_this.page_max_count_ == 0)
                return false;
            _this.list_loop("box_list_tbl", function (row) {
                var check = row.firstChild.firstChild;
                if (_this.page_sel_toggle_) {
                    check.checked = false;
                    row.removeAttribute("on-select");
                }
                else {
                    check.checked = true;
                    row.setAttribute("on-select", "true");
                }
                return false;
            });
            _this.page_sel_toggle_ = !_this.page_sel_toggle_;
            return false;
        };
        //#endregion
        //#region アップロード
        this.btn_upload = function () {
            var dlg_upload_file = util.js.gE("dlg_upload_file");
            var dlg_upload_name = util.js.gE("dlg_upload_name");
            var dlg_upload_sub = util.js.gE("dlg_upload_sub");
            dlg_upload_file.value = "";
            dlg_upload_name.value = "";
            dlg_upload_sub.value = "";
            _this.showDlg("dlg_upload");
            return false;
        };
        this.dlg_upload_cancel = function () {
            _this.closeDlg("dlg_upload");
        };
        this.dlg_upload_ok = function () {
            var dlg_upload_form = util.js.gE("dlg_upload_form");
            var dlg_upload_file = util.js.gE("dlg_upload_file");
            if (!dlg_upload_file.value) {
                _this.msg("ワーニング", "ファイルを選択してください。", function () { });
                return;
            }
            api_1.api.upload_file(_this.access_token_, new FormData(dlg_upload_form)).then(function (r) {
            }).catch(function (e) { return _this.apiError(e); });
            _this.closeDlg("dlg_upload");
        };
        //#endregion
        //#region プレビュー
        this.blobDisplay = function (r) {
            var blob = r;
            var a = document.createElement("a");
            var blobUrl = window.URL.createObjectURL(new Blob([blob], {
                type: blob.type
            }));
            document.body.appendChild(a);
            a.style.display = "none";
            a.href = blobUrl;
            a.target = "_blank";
            a.click();
        };
        this.btn_action_preview = function () {
            var datas = _this.checkSelect(1, []);
            if (!datas)
                return false;
            api_1.api.preview_file(_this.access_token_, datas[0].file_key).then(function (r) {
                _this.blobDisplay(r);
            }).catch(function (e) { return _this.apiError(e); });
            return false;
        };
        //#endregion
        //#region ダウンロード
        this.btn_action_download = function () {
            var datas = _this.checkSelect(1, []);
            if (!datas)
                return false;
            api_1.api.download_file(_this.access_token_, datas[0].file_key).then(function (r) {
                _this.blobDisplay(r);
            }).catch(function (e) { return _this.apiError(e); });
            return false;
        };
        //#endregion
        //#region 設定
        this.dlg_setting_file_key_ = "";
        this.btn_action_name = function () {
            var datas = _this.checkSelect(1, []);
            if (!datas)
                return false;
            var dlg_name = util.js.gE("dlg_setting_name");
            var dlg_sub = util.js.gE("dlg_setting_sub");
            dlg_name.value = datas[0].name;
            dlg_sub.value = datas[0].sub_type;
            _this.dlg_setting_file_key_ = datas[0].file_key;
            _this.showDlg("dlg_setting");
            return false;
        };
        this.dlg_setting_cancel = function () {
            _this.closeDlg("dlg_setting");
        };
        this.dlg_setting_ok = function () {
            var dlg_name = util.js.gE("dlg_setting_name");
            var dlg_sub = util.js.gE("dlg_setting_sub");
            api_1.api.property(_this.access_token_, _this.dlg_setting_file_key_, dlg_name.value, dlg_sub.value).then(function (r) {
                _this.get_page_list();
                _this.closeDlg("dlg_setting");
            }).catch(function (e) { return _this.apiError(e); });
        };
        //#endregion
        //#region コピー
        this.dlg_copy_file_key_ = "";
        this.btn_action_copy = function () {
            var datas = _this.checkSelect(1, []);
            if (!datas)
                return false;
            var dlg_name = util.js.gE("dlg_copy_name");
            var dlg_sub = util.js.gE("dlg_copy_sub");
            dlg_name.value = datas[0].name;
            dlg_sub.value = datas[0].sub_type;
            _this.dlg_copy_file_key_ = datas[0].file_key;
            _this.showDlg("dlg_copy");
            return false;
        };
        this.dlg_copy_cancel = function () {
            _this.closeDlg("dlg_copy");
        };
        this.dlg_copy_ok = function () {
            var dlg_name = util.js.gE("dlg_copy_name");
            var dlg_sub = util.js.gE("dlg_copy_sub");
            api_1.api.copy(_this.access_token_, _this.dlg_copy_file_key_, dlg_name.value, dlg_sub.value).then(function (r) {
                _this.get_page_list();
                _this.closeDlg("dlg_copy");
            }).catch(function (e) { return _this.apiError(e); });
        };
        //#endregion
        //#region sonbp
        this.btn_action_sonbp = function () {
            var datas = _this.checkSelect(1, ["application/pdf"]);
            if (!datas)
                return false;
            var file_key = datas[0].file_key;
            // sonbp_dtp.html
            // - file_key
            // - access_token
            // * - back_url
            // *- uri_prefix
            // *- uri_prefix_bp
            var params = "file_key=" + encodeURIComponent(file_key);
            params += "&access_token=" + encodeURIComponent(_this.access_token_);
            window.open('sonbp_dtp.html?' + params, '_blank');
            return false;
        };
        //#endregion
        //#region imposition
        this.btn_action_imp = function () {
            var datas = _this.checkSelect(-1, ["application/pdf"]);
            if (!datas)
                return false;
            var imp_data = {
                datas: [],
                meta: []
            };
            datas.some(function (d) {
                imp_data.datas.push({
                    files: [{ file: d.file_key }],
                    count: 1,
                    meta: []
                });
            });
            var imp_app_set = {
                // 面付データ
                imp_data: imp_data,
                // 面付で取り扱うのはローカルのデータファイルか？
                use_local_data: false,
                // アクセストークン
                access_token: _this.access_token_,
                // 戻りURL
                back_url: "",
                // URLプレフィックス
                //uri_prefix:api.uri_prefix,
                // 面付API（uri_file）プレフィックス
                //uri_file:"api/files",
                // データ変更可能モード（全般設定）
                can_data_change: false,
                // データ追加可能モード
                can_data_append: false,
                // データ編集可能モード
                can_data_edit: true,
                // データ並び替え可能モード
                can_data_sort: true,
                // データ削除可能モード
                can_data_remove: false,
                // 上部メニューを表示するか？
                display_head_menu: false,
                // データのアップロードが行えるか？（use_local_data==trueの時は未使用）
                can_data_upload: true,
                // 面付データファイル選択時の固定サブタイプ（use_local_data==trueの時は未使用）
                //select_subtype_data:"imp_data",
                // 余白ファイル選択時の固定サブタイプ（use_local_data==trueの時は未使用）
                //select_subtype_blank:"imp_blank",
                // 連続実行可能モード
                continuation: false,
            };
            sessionStorage.setItem('imp_app_set', JSON.stringify(imp_app_set));
            var win = open("imposition.html", "_blank");
            win.focus();
            return false;
        };
        //#endregion
        //#region deferx
        this.btn_action_defer = function () {
            var datas = _this.checkSelect(-3, ["text/lay", "text/x-lay"]);
            if (!datas)
                return false;
            var params = "";
            params += "access_token=" + encodeURIComponent(_this.access_token_);
            if (datas.length > 0) {
                params += "&file_key=" + encodeURIComponent(datas[0].file_key);
            }
            window.open('defer.html?' + params, '_blank');
            return false;
        };
        //#endregion
        //#region 削除
        this.btn_action_delete = function () {
            var datas = _this.checkSelect(1, []);
            if (!datas)
                return false;
            _this.msg("確認", "削除してもよろしいですか？", function () {
                api_1.api.delete_file(_this.access_token_, datas[0].file_key).then(function (r) {
                    _this.get_page_list();
                }).catch(function (e) { return _this.apiError(e); });
            }, "はい", function () { }, "いいえ");
            return false;
        };
        //#endregion
        //#region sysdir
        this.sysdir_sel_toggle_ = false;
        // show dialog.
        this.show_dlg_sysdir = function () {
            var ipt_sysdir_dirpath = util.js.gE("ipt_sysdir_dirpath");
            var ipt_sysdir_path = util.js.gE("ipt_sysdir_path");
            var dlg_sysdir_id = util.js.gE("dlg_sysdir_id");
            var dlg_sysdir_tbl = util.js.gE("dlg_sysdir_tbl");
            ipt_sysdir_dirpath.value = "";
            ipt_sysdir_path.value = "";
            dlg_sysdir_tbl.innerHTML = "";
            dlg_sysdir_id.innerHTML = "";
            _this.set_option(dlg_sysdir_id, "", "");
            api_1.api.dir_options(_this.access_token_).then(function (r) {
                var s = r.res;
                if (s.length == 0) {
                    _this.msg("ワーニング", "メンテナンスが行える対象がありません。", function () { });
                    return;
                }
                s.some(function (ss) { return _this.set_option(dlg_sysdir_id, ss.name, ss.id); });
                _this.get_sysdir_list();
            }).catch(function (e) { return _this.apiError(e); });
            _this.showDlg("dlg_sysdir");
        };
        // close sysdir
        this.dlg_sysdir_ok = function () {
            _this.closeDlg("dlg_sysdir");
        };
        // update list.
        this.get_sysdir_list = function (callbak) {
            if (callbak === void 0) { callbak = undefined; }
            var dlg_sysdir_tbl = util.js.gE("dlg_sysdir_tbl");
            dlg_sysdir_tbl.innerHTML = "";
            var crnt = _this.get_current_sysdir();
            if (!crnt)
                return;
            api_1.api.dir_list(_this.access_token_, { id: crnt.id, path: crnt.path }).then(function (r) {
                var s = r.res;
                var setrow = function (ss, isdir) {
                    var row = dlg_sysdir_tbl.insertRow(dlg_sysdir_tbl.rows.length);
                    row.setAttribute("name", ss.name);
                    row.setAttribute("is_dir", isdir ? "true" : "false");
                    row.onclick = function () { return _this.sysdir_list_row_select(row); };
                    var set = { time: null, cnt: 0 };
                    if (isdir) {
                        // dblclick
                        row.onmousedown = function () {
                            var is = false;
                            if (set.cnt = 1) {
                                if (Date.now() - set.time < 500)
                                    is = true;
                            }
                            if (is) {
                                _this.dlg_sysdir_allsel(false);
                                _this.sysdir_list_row_select(row);
                                set.cnt = 0;
                                _this.btn_sysdir_go();
                            }
                            else {
                                set.cnt = 1;
                                set.time = Date.now();
                            }
                        };
                    }
                    {
                        var cell = row.insertCell(0);
                        var check = util.js.cE("input");
                        check.type = "checkbox";
                        cell.append(check);
                    }
                    {
                        var cell = row.insertCell(1);
                        var icon = util.js.cE("span");
                        if (isdir) {
                            icon.setAttribute("uk-icon", "icon:folder; ratio: 0.8");
                            icon.classList.add("c-dlg-sysdir-diricon");
                        }
                        else {
                            icon.classList.add("c-dlg-sysdir-fileicon");
                        }
                        cell.append(icon);
                        var span_1 = util.js.cE("span");
                        span_1.innerText = ss.name;
                        span_1.classList.add("c-dlg-sysdir-rename");
                        span_1.onmousedown = function () {
                            span_1.style.display = "none";
                            ipt_1.style.display = "inline";
                            ipt_1.value = span_1.innerText;
                            ipt_1.onblur = function () { };
                            setTimeout(function () {
                                ipt_1.focus();
                                ipt_1.onblur = function () {
                                    span_1.style.display = "inline";
                                    ipt_1.style.display = "none";
                                    var src = row.getAttribute("name");
                                    if (src != ipt_1.value) {
                                        var path = crnt.path;
                                        if (path)
                                            path += "/";
                                        path += src;
                                        api_1.api.dir_rename(_this.access_token_, { id: crnt.id, path: path, post_name: ipt_1.value }).then(function (r) {
                                            row.setAttribute("name", ipt_1.value);
                                            span_1.innerText = ipt_1.value;
                                        }).catch(function (e) {
                                            ipt_1.value = src;
                                            _this.apiError(e);
                                        });
                                    }
                                };
                            }, 300);
                        };
                        cell.append(span_1);
                        var ipt_1 = util.js.cE("input");
                        ipt_1.classList.add("c-dlg-sysdir-rename-ipt");
                        ipt_1.style.display = "none";
                        ipt_1.onclick = function (e) { util.js.stopPropagation(e); return false; };
                        cell.append(ipt_1);
                    }
                    {
                        var cell = row.insertCell(2);
                        cell.innerText = util.js.formatDay(ss.updated);
                    }
                };
                s.dirs.some(function (ss) { return setrow(ss, true); });
                s.files.some(function (ss) { return setrow(ss, false); });
                if (callbak)
                    callbak();
            }).catch(function (e) { return _this.apiError(e); });
        };
        // select by row for list.
        this.sysdir_list_row_select = function (row) {
            var onsel = row.getAttribute("on-select");
            var check = row.firstChild.firstChild;
            if (onsel && onsel == "true") {
                check.checked = false;
                row.removeAttribute("on-select");
            }
            else {
                check.checked = true;
                row.setAttribute("on-select", "true");
            }
            _this.dlg_sysdir_set_selpath();
        };
        // select by all for list.
        this.dlg_sysdir_allsel = function (sel) {
            _this.list_loop("dlg_sysdir_tbl", function (row) {
                var check = row.firstChild.firstChild;
                if (!sel) {
                    check.checked = false;
                    row.removeAttribute("on-select");
                }
                else {
                    check.checked = true;
                    row.setAttribute("on-select", "true");
                }
                return false;
            });
            _this.dlg_sysdir_set_selpath();
        };
        // select by name for list.
        this.dlg_sysdir_namesel = function (name) {
            _this.list_loop("dlg_sysdir_tbl", function (row) {
                var check = row.firstChild.firstChild;
                if (row.getAttribute("name") != name) {
                    check.checked = false;
                    row.removeAttribute("on-select");
                }
                else {
                    check.checked = true;
                    row.setAttribute("on-select", "true");
                }
                return false;
            });
            _this.dlg_sysdir_set_selpath();
        };
        // select by toggle for list.
        this.dlg_sysdir_head_sel = function () {
            _this.dlg_sysdir_allsel(!_this.sysdir_sel_toggle_);
            _this.sysdir_sel_toggle_ = !_this.sysdir_sel_toggle_;
            return false;
        };
        // set for row info.
        this.dlg_sysdir_set_selpath = function () {
            var ipt_sysdir_path = util.js.gE("ipt_sysdir_path");
            var rows = _this.get_select_sysdir_rows();
            ipt_sysdir_path.value = rows.map(function (r) {
                var rt = r.path;
                if (rt)
                    rt += "/";
                rt += r.name;
                return rt;
            }).join(";");
        };
        // copy info.
        this.btn_sysdir_pathcp = function () {
            var ipt_sysdir_path = util.js.gE('ipt_sysdir_path');
            navigator.clipboard.writeText(ipt_sysdir_path.value);
        };
        // get selected rows.
        this.get_select_sysdir_rows = function () {
            var result = [];
            var ipt_sysdir_dirpath = util.js.gE("ipt_sysdir_dirpath");
            var path = ipt_sysdir_dirpath.value;
            _this.list_loop("dlg_sysdir_tbl", function (row) {
                if (row.getAttribute("on-select") == "true") {
                    var name_2 = row.getAttribute("name");
                    var is_dir = row.getAttribute("is_dir") == "true";
                    result.push({ name: name_2, is_dir: is_dir, path: path });
                }
                return false;
            });
            return result;
        };
        // change sysdir id.
        this.dlg_sysdir_id = function () {
            var ipt_sysdir_dirpath = util.js.gE("ipt_sysdir_dirpath");
            var ipt_sysdir_path = util.js.gE("ipt_sysdir_path");
            ipt_sysdir_dirpath.value = "";
            ipt_sysdir_path.value = "";
            _this.get_sysdir_list();
        };
        // get sysdir id & path.
        this.get_current_sysdir = function () {
            var dlg_sysdir_id = util.js.gE("dlg_sysdir_id");
            if (!dlg_sysdir_id.value)
                return null;
            var ipt_sysdir_dirpath = util.js.gE("ipt_sysdir_dirpath");
            return {
                id: dlg_sysdir_id.value,
                path: ipt_sysdir_dirpath.value
            };
        };
        // back for dir.
        this.btn_sysdir_back = function () {
            var crnt = _this.get_current_sysdir();
            if (!crnt)
                return;
            if (!crnt.path)
                return;
            var sp = crnt.path.split("/");
            sp.splice(sp.length - 1, 1);
            var path = sp.join("/");
            var ipt_sysdir_dirpath = util.js.gE("ipt_sysdir_dirpath");
            var ipt_sysdir_path = util.js.gE("ipt_sysdir_path");
            ipt_sysdir_dirpath.value = path;
            ipt_sysdir_path.value = "";
            _this.get_sysdir_list();
        };
        // go for dir.
        this.btn_sysdir_go = function () {
            var crnt = _this.get_current_sysdir();
            if (!crnt)
                return;
            var sel = _this.get_select_sysdir_rows();
            if (sel.length != 1 || !sel[0].is_dir)
                return;
            var path = crnt.path;
            if (path)
                path += "/";
            path += sel[0].name;
            var ipt_sysdir_dirpath = util.js.gE("ipt_sysdir_dirpath");
            var ipt_sysdir_path = util.js.gE("ipt_sysdir_path");
            ipt_sysdir_dirpath.value = path;
            ipt_sysdir_path.value = "";
            _this.get_sysdir_list();
            _this.sysdir_sel_toggle_ = false;
        };
        // create dir.
        this.btn_sysdir_folder = function () {
            var crnt = _this.get_current_sysdir();
            if (!crnt)
                return;
            api_1.api.dir_create(_this.access_token_, { id: crnt.id, path: crnt.path, name: "" }).then(function (r) {
                var data = r.res;
                console.log(data.name);
                _this.get_sysdir_list(function () {
                    console.log(data.name);
                    _this.dlg_sysdir_namesel(data.name);
                });
            }).catch(function (e) { return _this.apiError(e); });
        };
        // download files.
        this.btn_sysdir_download = function () {
            var crnt = _this.get_current_sysdir();
            if (!crnt)
                return;
            var sel = _this.get_select_sysdir_rows();
            if (sel.length == 0) {
                _this.msg("ワーニング", "対象を1件以上選択してください。", function () { });
                return;
            }
            api_1.api.dir_download(_this.access_token_, { id: crnt.id, path: crnt.path, names: sel.map(function (m) { return m.name; }) }).then(function (r) {
                _this.zipSave(r.res);
            }).catch(function (e) { return _this.apiError(e); });
        };
        // save zip.
        this.zipSave = function (r) {
            var blob = r;
            var a = document.createElement("a");
            var blobUrl = window.URL.createObjectURL(new Blob([blob], {
                type: blob.type
            }));
            document.body.appendChild(a);
            a.style.display = "none";
            a.href = blobUrl;
            a.download = "download.zip";
            a.click();
        };
        // upload files.
        this.btn_sysdir_upload_ipt = function () {
            var crnt = _this.get_current_sysdir();
            if (!crnt)
                return;
            var ipt = util.js.gE("btn_sysdir_upload_ipt");
            if (ipt.files.length == 0)
                return;
            var upload = function (i) {
                var form = new FormData();
                form.append('file', ipt.files[i]);
                form.append('name', ipt.files[i].name);
                form.append('path', crnt.path);
                form.append('id', crnt.id);
                api_1.api.dir_upload(_this.access_token_, form).then(function (r) {
                    if (i < ipt.files.length - 1) {
                        upload(i + 1);
                    }
                    else {
                        ipt.value = "";
                    }
                }).catch(function (e) { return _this.apiError(e); }).finally(function () {
                    _this.get_sysdir_list();
                });
            };
            upload(0);
        };
        // delete files.
        this.btn_sysdir_del = function () {
            var crnt = _this.get_current_sysdir();
            if (!crnt)
                return;
            var sel = _this.get_select_sysdir_rows();
            if (sel.length != 1) {
                _this.msg("ワーニング", "対象を1件選択してください。", function () { });
                return;
            }
            _this.msg("確認", "削除してもよろしいですか？", function () {
                var path = crnt.path;
                if (path)
                    path += "/";
                path += sel[0].name;
                api_1.api.dir_delete(_this.access_token_, { id: crnt.id, path: path }).then(function (r) {
                    _this.get_sysdir_list();
                }).catch(function (e) { return _this.apiError(e); });
            }, "はい", function () { }, "いいえ");
        };
        //#endregion
        //#region token
        this.show_dlg_token = function () {
            var ckey = localStorage.getItem('client_key');
            var secret = localStorage.getItem('client_secret');
            var pkey = localStorage.getItem('client_pem');
            var iss = localStorage.getItem('client_token_iss');
            var sub = localStorage.getItem('client_token_sub');
            var grp = localStorage.getItem('client_token_grp');
            util.js.gE("dlg_token_key").value = ckey;
            util.js.gE("dlg_token_secret").value = secret;
            util.js.gE("dlg_token_private").value = pkey;
            util.js.gE("dlg_token_iss").value = iss;
            util.js.gE("dlg_token_sub").value = sub;
            util.js.gE("dlg_token_grp").value = grp;
            _this.showDlg("dlg_token");
        };
        this.dlg_token_cancel = function () {
            _this.closeDlg("dlg_token");
        };
        this.dlg_token_ok = function () {
            var ckey = util.js.gE("dlg_token_key").value;
            var secret = util.js.gE("dlg_token_secret").value;
            var pkey = util.js.gE("dlg_token_private").value;
            var iss = util.js.gE("dlg_token_iss").value;
            var sub = util.js.gE("dlg_token_sub").value;
            var grp = util.js.gE("dlg_token_grp").value;
            var is_save = util.js.gE("dlg_token_save").checked;
            var pkey_raw = pkey;
            pkey_raw = pkey_raw.replace("-----BEGIN RSA PRIVATE KEY-----", "");
            pkey_raw = pkey_raw.replace("-----END RSA PRIVATE KEY-----", "");
            pkey_raw = pkey_raw.replace(/\r/g, '');
            pkey_raw = pkey_raw.replace(/\n/g, '');
            var token = jwt.sign({
                aud: "catalana",
                iss: iss,
                sub: sub,
                catalana_sub_groups: grp,
            }, pkey_raw, {
                algorithm: 'HS256',
                expiresIn: 3,
            });
            api_1.api.auth_token({ grant_type: "client_credentials", auth_token: token, client_key: ckey, client_secret: secret }).then(function (r) {
                var data = r.res;
                console.log(data);
                if (is_save) {
                    localStorage.setItem('client_key', ckey);
                    localStorage.setItem('client_secret', secret);
                    localStorage.setItem('client_pem', pkey);
                    localStorage.setItem('client_token_iss', iss);
                    localStorage.setItem('client_token_sub', sub);
                    localStorage.setItem('client_token_grp', grp);
                }
                util.js.gE("ipt_token").value = data.access_token;
                _this.access_token_ = data.access_token;
                _this.closeDlg("dlg_token");
            }).catch(function (e) { return _this.apiError(e); });
        };
        // バージョン表示
        console.log('%c' + ' catalana ' + '%c%c ' + this.app_version_ + ' %c%c ' + this.app_hash_ + ' %c', 'background-color:#666;color:#fff', '', 'background-color:#888;color:#fff', '', 'background-color:#666;color:#fff', '');
        util.js.gE("btn_token").onclick = this.btn_token;
        util.js.gE("dlg_token_cancel").onclick = this.dlg_token_cancel;
        util.js.gE("dlg_token_ok").onclick = this.dlg_token_ok;
        util.js.gE("ipt_search_name").onkeydown = this.ipt_cond_keydown;
        util.js.gE("ipt_search_subtype").onkeydown = this.ipt_cond_keydown;
        util.js.gE("btn_search").onclick = this.btn_search;
        util.js.gE("btn_upload").onclick = this.btn_upload;
        util.js.gE("dlg_upload_ok").onclick = this.dlg_upload_ok;
        util.js.gE("dlg_upload_cancel").onclick = this.dlg_upload_cancel;
        util.js.gE("box_list_head_sel").onclick = this.box_list_head_sel;
        util.js.gE("btn_action_preview").onclick = this.btn_action_preview;
        util.js.gE("btn_action_download").onclick = this.btn_action_download;
        util.js.gE("btn_action_name").onclick = this.btn_action_name;
        util.js.gE("dlg_setting_ok").onclick = this.dlg_setting_ok;
        util.js.gE("dlg_setting_cancel").onclick = this.dlg_setting_cancel;
        util.js.gE("btn_action_copy").onclick = this.btn_action_copy;
        util.js.gE("dlg_copy_ok").onclick = this.dlg_copy_ok;
        util.js.gE("dlg_copy_cancel").onclick = this.dlg_copy_cancel;
        util.js.gE("btn_action_sonbp").onclick = this.btn_action_sonbp;
        util.js.gE("btn_action_imp").onclick = this.btn_action_imp;
        util.js.gE("btn_action_defer").onclick = this.btn_action_defer;
        util.js.gE("btn_action_delete").onclick = this.btn_action_delete;
        util.js.gE("btn_swagger").onclick = this.btn_swagger;
        util.js.gE("btn_sysdir").onclick = this.btn_sysdir;
        util.js.gE("dlg_sysdir_ok").onclick = this.dlg_sysdir_ok;
        util.js.gE("btn_sysdir_back").onclick = this.btn_sysdir_back;
        util.js.gE("btn_sysdir_folder").onclick = this.btn_sysdir_folder;
        util.js.gE("btn_sysdir_download").onclick = this.btn_sysdir_download;
        util.js.gE("btn_sysdir_del").onclick = this.btn_sysdir_del;
        util.js.gE("btn_sysdir_pathcp").onclick = this.btn_sysdir_pathcp;
        util.js.gE("dlg_sysdir_head_sel").onclick = this.dlg_sysdir_head_sel;
        util.js.gE("dlg_sysdir_id").onchange = this.dlg_sysdir_id;
        util.js.gE("btn_sysdir_upload_ipt").onchange = this.btn_sysdir_upload_ipt;
        this.createButtons(s);
        window.onresize = function () { return _this.window_resize(); };
        this.window_resize();
    }
    return main;
}());
exports.main = main;
